import { render, staticRenderFns } from "./AgreementField.vue?vue&type=template&id=2f8c3314&scoped=true"
import script from "./AgreementField.vue?vue&type=script&lang=js"
export * from "./AgreementField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c3314",
  null
  
)

export default component.exports